export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
  },
  {
    path: '/home',
    name: 'Home',
  },
  {
    path: '/school',
    name: 'School',
  },
  {
    path: '/schools',
    name: 'Schools',
  },
  {
    path: '/accounts',
    name: 'Accounts',
  },
  {
    path: '/account',
    name: 'Account',
  },
  {
    path: '/applications/:school_id',
    name: 'Applications',
  },
  {
    path: '/notifications',
    name: 'Notifications',
  },
  {
    path: '/notification',
    name: 'Notification',
  },
  {
    path: '/recompose/:request_code',
    name: 'Recompose',
  },
  {
    path: '/contents',
    name: 'Contents',
  },
  {
    path: '/content/:id',
    name: 'Content',
  },
  {
    path: '/content_master_import',
    name: 'ContentMasterImport',
  },
  {
    path: '/content_fiscal_year_import',
    name: 'ContentFiscalYearImport',
  },
  {
    path: '/presets',
    name: 'Presets',
  },
  {
    path: '/preset/:id',
    name: 'Preset',
  },
  {
    path: '/csv_output',
    name: 'CsvOutput',
  },
  {
    path: '/maintenance',
    name: 'Maintenance',
  },
]
